import { render, staticRenderFns } from "./LanguageDropDown.vue?vue&type=template&id=3a5d7394&scoped=true"
import script from "./LanguageDropDown.vue?vue&type=script&lang=js"
export * from "./LanguageDropDown.vue?vue&type=script&lang=js"
import style0 from "./LanguageDropDown.vue?vue&type=style&index=0&id=3a5d7394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5d7394",
  null
  
)

export default component.exports